// extracted by mini-css-extract-plugin
export default {"experiencesSectionRoot":"experiencesection_experiencesSectionRoot__0Gnt8","sectionContainer":"experiencesection_sectionContainer__hO7IM"};